// extracted by mini-css-extract-plugin
module.exports = {"desk":"Grid_desk_3Kad3","table":"Grid_table_3YK0q","docType":"Grid_docType_1U6cw","docNumber":"Grid_docNumber_LXx9l"};